// src/componants/SellerLayout.tsx

import React from 'react';
import { Link, Outlet } from "react-router-dom";
import SellerHeader from "./SellerHeader";
// SellerSidebar अब यहाँ import नहीं होगा

const SellerLayout: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Header */}
            <SellerHeader />

            {/* Main Content Area (pt-[64px] for new h-[64px] header) */}
            <div className="flex flex-grow pt-[64px]"> 

                {/* Dashboard Content: अब कोई Sidebar नहीं है */}
                <main className="flex-grow p-4 md:p-6 transition-all duration-300">
                    <Outlet /> {/* Seller Dashboard components will render here */}
                </main>
            </div>

            {/* Footer */}
           <footer className="relative w-full bg-gray-900 text-white mt-12">
  {/* Angled Top */}
  <div className="absolute -top-8 left-0 w-full overflow-hidden leading-0">
    <svg className="relative block w-full h-8" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1200 120">
      <path d="M0,0 V120 H1200 V0 L0,0 Z" className="fill-gray-900"></path>
    </svg>
  </div>

  <div className="max-w-7xl mx-auto px-6 py-12 md:py-16 flex flex-col md:flex-row justify-between items-start space-y-8 md:space-y-0">
    
    {/* Left: Company Info */}
    <div className="md:w-1/2 space-y-4">
      <h1 className="text-2xl md:text-3xl font-bold tracking-wide text-red-600">B2Bhaart</h1>
      <p className="text-gray-300 text-sm md:text-base">
        India's Largest B2B Marketplace, Connecting Buyers and Sellers.
      </p>
      <p className="text-gray-500 text-xs md:text-sm">
        Privacy Policy - Terms of Use © 1999-2025 Infocom Network Private Limited. All rights reserved.
      </p>
    </div>

    {/* Right: Links + Social */}
    <div className="md:w-1/2 flex flex-col md:flex-row md:justify-end md:items-start space-y-6 md:space-y-0 md:space-x-12">
      
      {/* Quick Links */}
      <div className="flex flex-col space-y-2">
        <h2 className="font-semibold text-gray-200">Quick Links</h2>
        <Link to="/privacy" className="hover:underline hover:text-green-400 transition-all duration-300">Privacy Policy</Link>
        <Link to="/terms" className="hover:underline hover:text-green-400 transition-all duration-300">Terms of Use</Link>
        <Link to="/contact" className="hover:underline hover:text-green-400 transition-all duration-300">Contact Us</Link>
      </div>

      {/* Follow Us */}
      <div className="flex flex-col space-y-2">
        <h2 className="font-semibold text-gray-200">Follow Us</h2>
        <div className="flex space-x-4">
          {/* Twitter */}
          <a href="#" className="transform hover:-translate-y-1 hover:scale-110 transition-all duration-300 bg-gradient-to-r from-blue-400 to-blue-600 p-2 rounded-full text-white shadow-lg">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.27 4.27 0 0 0 1.88-2.37 8.42 8.42 0 0 1-2.7 1.03 4.23 4.23 0 0 0-7.2 3.86A12 12 0 0 1 3.15 4.57a4.23 4.23 0 0 0 1.31 5.64 4.21 4.21 0 0 1-1.92-.53v.05a4.23 4.23 0 0 0 3.38 4.14 4.23 4.23 0 0 1-1.91.07 4.23 4.23 0 0 0 3.95 2.94A8.48 8.48 0 0 1 2 19.54 12 12 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.35-.02-.53A8.35 8.35 0 0 0 22.46 6z"/>
            </svg>
          </a>
          {/* Instagram */}
          <a href="#" className="transform hover:-translate-y-1 hover:scale-110 transition-all duration-300 bg-gradient-to-r from-pink-500 to-yellow-400 p-2 rounded-full text-white shadow-lg">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.96.24 2.418.403a4.91 4.91 0 0 1 1.78 1.06 4.91 4.91 0 0 1 1.06 1.78c.164.46.35 1.25.403 2.418.058 1.266.07 1.65.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.96-.403 2.418a4.91 4.91 0 0 1-1.06 1.78 4.91 4.91 0 0 1-1.78 1.06c-.46.164-1.25.35-2.418.403-1.266.058-1.65.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.96-.24-2.418-.403a4.91 4.91 0 0 1-1.78-1.06 4.91 4.91 0 0 1-1.06-1.78c-.164-.46-.35-1.25-.403-2.418C2.212 15.584 2.2 15.2 2.2 12s.012-3.584.07-4.85c.054-1.17.24-1.96.403-2.418a4.91 4.91 0 0 1 1.06-1.78 4.91 4.91 0 0 1 1.78-1.06c.46-.164 1.25-.35 2.418-.403C8.416 2.212 8.8 2.2 12 2.2z"/>
            </svg>
          </a>
          {/* LinkedIn */}
          <a href="#" className="transform hover:-translate-y-1 hover:scale-110 transition-all duration-300 bg-gradient-to-r from-blue-600 to-blue-800 p-2 rounded-full text-white shadow-lg">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm.02 4.5H2V21h3V8zm7.5 0h-3v13h3v-6.5c0-3 4-3.25 4 0V21h3v-7c0-5-5.5-4.85-5-2.5V8z"/>
            </svg>
          </a>
        </div>
      </div>

    </div>
  </div>

  {/* Bottom Bar */}
  <div className="mt-8 border-t border-gray-700 py-4 text-center text-gray-500 text-xs">
    © 2024 B2Bhaart. All rights reserved.
  </div>
</footer>

        </div>
    );
};

export default SellerLayout;